import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router';
import { Link } from 'react-router-dom';
import { Button } from 'components/ui/button';
import { ChevronRight } from 'lucide-react';


const Sequence = [
    {
        no: 1,
        name: "Services",
        value: "services",
        link: "onboarding/services"
    },
    {
        no: 2,
        name: "White Label",
        value: "white-label",
        link: "onboarding/white-label"
    },
    {
        no: 3,
        name: "Category",
        value: "category",
        link: "onboarding/category"
    },
    {
        no: 4,
        name: "Template",
        value: "email-template",
        link: "onboarding/email-template"
    },
    {
        no: 5,
        name: "Questions",
        value: "questions",
        link: "onboarding/questions"
    },
    {
        no: 6,
        name: "Survey (tokens)",
        value: "emails",
        link: "onboarding/emails"
    },
    {
        no: 7,
        name: "Survey Customizations",
        value: "survey-customizations",
        link: "onboarding/survey-customizations"
    }
]

const NavigationBar = ({ organizationId }) => {
    const navigate = useNavigate()
    const location = useLocation()
    let urlElements = location.pathname.split('/')
    

    const [urlLocation, setUrlLocation] = useState(false)
    const [showHome, setShowHome] = useState(false)

    useEffect(() => {
        setShowHome(false)
        setUrlLocation(false)
        const LastElement = urlElements[urlElements.length - 1]

        if (!Number.isInteger(Number(LastElement))) {
            setShowHome(true)
            setUrlLocation(LastElement)
        }

    }, [urlElements]);

    const detailsBase = `/app/organizations/details/${organizationId}`

    if (!organizationId) {
        navigate("/app/organizations")
    }

    // console.log(urlLocation)

    return (
        <div className="w-full overflow-x-auto">
            <div className="flex items-center gap-2 py-2 min-w-max">
                {showHome && (
                    <Link
                        to={detailsBase}
                        className="inline-flex items-center whitespace-nowrap rounded-md border bg-background px-3 py-1.5 text-sm font-medium text-foreground hover:bg-muted"
                    >
                        Overview
                    </Link>
                )}
                {Sequence.map((bx, i) => {
                    const isActive = bx.value === urlLocation
                    return (
                        <Link
                            key={bx.value}
                            to={`${detailsBase}/${bx.link}`}
                            className={
                                `inline-flex items-center gap-2 whitespace-nowrap rounded-md px-3 py-1.5 text-sm font-medium ` +
                                (isActive ? 'bg-primary text-primary-foreground' : 'border bg-background text-muted-foreground hover:bg-muted')
                            }
                        >
                            <span className={
                                `inline-flex h-5 w-5 items-center justify-center rounded-full text-[11px] ` +
                                (isActive ? 'bg-primary-foreground text-primary' : 'bg-muted text-foreground')
                            }>
                                {bx.no}
                            </span>
                            <span>{bx.name}</span>
                        </Link>
                    )
                })}
            </div>
        </div>
    );
};

export default NavigationBar;
